import * as React from 'react';

// Utils
import { useTranslation } from '@shopee-user/platform';

// Components
import {
  AccessibleSpan,
  InputCheckbox,
} from '@shopee-user/shared-customization-ui';

// Constants
import { config } from '@shopee-user/platform';

// Types
import { SignupTermsOfServiceProps } from '@shopee-user/business-customization-types';

import styles from './style.scss';

export default function SignupTermsOfService({
  onTermsOfServiceClick,
  onPrivacyPolicyClick,
  onCheckboxClick,
  checked,
}: SignupTermsOfServiceProps) {
  const I18n = useTranslation();

  return (
    <InputCheckbox
      className={styles.agreementCheckbox}
      label={I18n.tNode('msg_auth_i_agree_to_terms', {
        context: config.BUSINESS_TARGET,
        terms_of_service: (
          <AccessibleSpan
            className={styles.link}
            role="link"
            onClick={event => onTermsOfServiceClick(event)}
          >
            {I18n.t('msg_auth_terms_of_service')}
          </AccessibleSpan>
        ),
        privacy_policy: (
          <AccessibleSpan
            className={styles.link}
            role="link"
            onClick={event => onPrivacyPolicyClick(event)}
          >
            {I18n.t('msg_auth_privacy_policy')}
          </AccessibleSpan>
        ),
      })}
      checked={checked}
      onClick={(checked: boolean) => {
        onCheckboxClick?.(checked);
      }}
    />
  );
}
